<template>
    <div class="container mt-2">
        <div v-if="showList">
            <!--v-if="windowWidth>maxMobilSize"-->
            <grid  @editProcess="getProcessId($event)" :columns="gridColumns" :tableConfigVisible="tableConfigVisible" :user="user" :users="users" :page="pageIs" :data="gridData"></grid>

           <!-- <gridMobil v-else :columns="gridColumns" @editProcess="getProcessId($event)" :tableConfigVisible="tableConfigVisible" :user="user" :users="users" :data="gridData" :page="pageIs" ></gridMobil>-->
            </div>
        <div v-else>
            <renderForm :form="formData" @update="updateProcessF($event)" @cancel="cancel"/>
        </div>

        <!-- create process modal begin-->
        <div class="modal fade" id="addProcessModal" tabindex="-1" aria-labelledby="addProcessModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title createProcessModalHeader" id="addProcessModalLabel">{{$ml.get('CREATE_PROCESS')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body pt-3 pb-5">
                   <div class="row">
                        <div class="col-12">
                            <label class="new-label">{{$ml.get('PROCESS_NAME')}}</label>
                            <input type="text" v-model="processName" class="new-input">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <label class="new-label">{{$ml.get('FORMS')}}</label>
                            <select class="new-select bg-white" @change="changeForm($event)">
                              <option selected>{{$ml.get('SELECT')}}</option>
                              <option v-for="(form,index) in listForms" :key="index" :selected="selectForm===form._id">{{form.name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer noteBtnStyle">
                    <button @click="closeButton()" type="button" class="btn-new" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                    <button @click="addProcessF()" data-dismiss="modal" type="button" class="btn-new save ml-1">{{$ml.get('SAVE')}}</button>
                </div>
                </div>
            </div>
        </div>
        <!-- create process modal end -->

        <!-- Değişiklik uyarısı CreateProcess modal -->
    
        <div class="modal fade h-100" id="createProcessAlertModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true" style="z-index:99999;">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content px-2 py-3 bg-white" >
                    <div class="modal-body text-center">
                        <i class="fas fa-exclamation-circle danger fa-3x" style="background: #FF0000; color: #fff; padding: 1.5rem; border-radius: 50%;"></i>
                        <h2 class="my-3" style="color:#47495A;">Uyarı</h2>
                        <p style="color: #53565E; font-size: 16px;">
                            Değişiklikleri kaydetmek istiyor musunuz?
                        </p>
                    </div>
                    <div class="modal-footer d-flex align-items-center justify-content-center">
                        <button type="button" class="btn bg-transparent btn-lg mr-2" style="font-weight: 500; font-size: 16px;" data-dismiss="modal">{{$ml.get('NO')}}</button>
                        <button @click="addProcessF()" type="button" class="btn btn-lg" style="background: #FF0000; color: #fff; font-weight: 600; font-size: 16px;" data-dismiss="modal" >{{$ml.get('YES')}}</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Değişiklik uyarısı UpdateProcess modal -->
    
        <div class="modal fade h-100" id="updateProcessAlertModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true" style="z-index:99999;">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content px-2 py-3 bg-white" >
                    <div class="modal-body text-center">
                        <i class="fas fa-exclamation-circle danger fa-3x" style="background: #FF0000; color: #fff; padding: 1.5rem; border-radius: 50%;"></i>
                        <h2 class="my-3" style="color:#47495A;">Uyarı</h2>
                        <p style="color: #53565E; font-size: 16px;">
                            Değişiklikleri kaydetmek istiyor musunuz?
                        </p>
                    </div>
                    <div class="modal-footer d-flex align-items-center justify-content-center">
                        <button type="button" class="btn bg-transparent btn-lg mr-2" style="font-weight: 500; font-size: 16px;" data-dismiss="modal">{{$ml.get('NO')}}</button>
                        <button @click="updateProcessF()" type="button" class="btn btn-lg" style="background: #FF0000; color: #fff; font-weight: 600; font-size: 16px;" data-dismiss="modal" >{{$ml.get('YES')}}</button>
                    </div>
                </div>
            </div>
        </div>

        <notifications group="foo" style="margin-right:5%;margin-top:2%" position="top right" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Grid from './Grid'
import GridMobil from "./gridMobil";
import renderForm from "./renderForm.vue"

export default {
    components: {
        "grid":Grid,
        "gridMobil":GridMobil,
        renderForm
    },
    name: "formProcess",
  
    data () {
        return {
            gridColumns:[
                {prop:'_id',name:"Id",default:true},
                {prop:'name',name:this.$ml.get('PROCESS_NAME'),default:true,type:"name",valid:true},
                {prop:'form',name:this.$ml.get('FORM_NAME'),default:true,type:"formObj",valid:true},
                {prop:'add_date',name:this.$ml.get('CREATION_DATE'), type:"dateObj", default:true, valid:true},
                {prop:'current_step',name:this.$ml.get('STEP_NAME'),default:true, type:"stepObj",valid:true},
                {prop:'cuid', name: this.$ml.get('CREATED_BY'), type:"user", default:true},
            ],
            tableConfigVisible:[],
            pagingSize:30,
            pagingOffset:0,
            processes:[],
            firstLoad:true,
            user:{},
            users:[],
            permissions:[],
            pageIs:'process',
            gridData:[],
            contactsRow:[],
            listForms:[],
            processName:"",
            selectForm:"",
            stepId:"",
            updateProcessData:{},
            UpdateProcessName:"",
            updateFormName:"",
            showList: true,
            formData: {}
            
        }
    },
     computed:{
        ...mapState([
            'baseUrl',
            'windowWidth',
            'maxMobilSize',
            'maxTabletSize',
            'editLine',
        ]),
        
    },
    created(){
        this.$root.$refs.formProcess = this
    },

    mounted(){
        this.getUsersF()
        this.getAllFormsF()
        this.getClosedProcessesF()
    },
    
    methods: {
        addProcessModal(){
            $('#addProcessModal').modal('show')
        },
        closeButton(){
            $('#createProcessAlertModal').modal('show')
            this.processName=""
            this.selectForm=""
        },
        closeButtonUpdate(){
            $('#updateProcessAlertModal').modal('show')
            this.processName=""
            this.selectForm=""
        },
        changeForm(event){
            this.selectForm=this.listForms[event.target.selectedIndex-1]._id
            this.stepId=this.listForms[event.target.selectedIndex-1].flow
        },
        getProcessId(event){
            this.getProcessF(event)
        },
        getAllFormsF(){
            axios({
                method:'POST',
                url:'/getAllForms',
                baseURL: this.baseUrl,
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status){
                    if(res.data.status.code==0){
                        this.listForms = res.data.content.forms[0]
                    }
                }else{

                }
            })
        },
        getFormsF(){
                axios({
                    method:'POST',
                    url:'/getForms',
                    baseURL: this.baseUrl,
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            // this.listForms = res.data.content.forms[0]
                            
                        }else{

                        }
                    }else{

                    }
                })
        },
        updateProcessF(obj){
            console.log(obj);
            axios({
                method:'POST',
                url:'/updateProcess',
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status){
                    if(res.data.status.code==0){
                        this.getProcessesF()
                        this.$emit("changeHeader")
                        this.showList = true
                    }else{
                        
                    }
                }else{
                
                }
            })
        },
        addProcessF(){
            if(this.processName!=="" && this.selectForm!==undefined && this.selectForm!==""){
              
                axios({
                    method:'POST',
                    url:'/addProcess',
                    baseURL: this.baseUrl,
                    data: {
                        form_id:this.selectForm.$oid,
                        data:{},
                        current_step:this.stepId.sequence[0],
                        name:this.processName,
                        customerFileIds: []
                    },
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            this.getProcessesF()
                            this.processName=""
                            this.selectForm=""
                        }else{
                            alert("hata")
                        }
                    }else{
                   
                    }
                })
            }
            else{
                   this.$notify({ 
                            group: 'foo',
                            type: 'warning', 
                            title: this.$ml.get('WARNING'),
                            text: "Process name ve forms alanı boş geçilemez."
                        })
                    this.processName=""
                    this.selectForm=""
            }
        },

        getProcessF(id){
            axios({
                method:'POST',
                url:'/getProcess',
                baseURL: this.baseUrl,
                data: {
                    processId: id,
                },
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status){
                    if(res.data.status.code==0){
                        this.formData = res.data.content.process
                        this.showList = false
                        this.$root.$refs.Process.showPageHeader = false
                    }else{
                        
                    }
                }else{
                    
                }
            })
        },

        getProcessesF(){
            axios({
                method:'POST',
                url:'/getProcesses',
                baseURL: this.baseUrl,
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status){
                    if(res.data.status.code==0){
                        if(this.firstLoad){
                            for(var col in this.gridColumns){
                                if(this.gridColumns[col]['default']){
                                    this.tableConfigVisible.push(this.gridColumns[col]['prop'])
                                }
                            }
                        }
                        this.firstLoad=false

                        const processes = res.data.content.processes && res.data.content.processes[0]
                        if(processes){
                            var processList = []
                            let columns =this.gridColumns
                            for (var contactObjIter in processes){
                                this.contactsRow.push(processes[contactObjIter])
                                let obj={}
                                let contactObj =processes[contactObjIter]
                                for(var column in columns){
                                    var colInActivity = contactObj.hasOwnProperty(columns[column]['prop'])

                                    if(colInActivity){
                                        
                                        let edObj={}

                                        if(columns[column]['type']==='stepObj'){
                                            
                                            const steps = contactObj.form && contactObj.form.flow && contactObj.form.flow.steps
                                            edObj['val']=steps && steps[contactObj['current_step']] ? steps[contactObj['current_step']] : ''
                                            edObj['isEditMode']=false
                                            edObj['type']=columns[column]['type']
                                            // edObj['current_step']=contactObj[columns[column]['prop']]
                                            obj[columns[column]['prop']]=edObj
                                            
                                        }else{
                                            edObj['val']=contactObj[columns[column]['prop']]
                                            edObj['isEditMode']=false
                                            edObj['type']=columns[column]['type']
                                            obj[columns[column]['prop']]=edObj
                                        }

                                    }
                                    else{
                                        let edObj={}
                                        edObj['val']=null
                                        edObj['isEditMode']=false
                                        edObj['type']=columns[column]['type']
                                        if(columns[column]['type']=='dateObj'){
                                            let date = {}
                                            date['$date']=''
                                            edObj['val']=date
                                            
                                        }
                                        obj[columns[column]['prop']]=edObj
                                    }
                                }
                                processList.push(obj)
                                
                            }
                            this.gridData = processList
                            processList.reverse()
                        }
                    }
                }else{
                    
                }
            })
        },
        getClosedProcessesF(){
            axios({
                method:'POST',
                url:'/getClosedProcesses',
                baseURL: this.baseUrl,
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status){
                    if(res.data.status.code==0){
                        // console.log("---------------");
                        // console.log(res.data);
                    }
                }
            })
        },
        getAllProcessesF() {
            axios({
                method:'POST',
                url:'/getAllProcesses',
                baseURL: this.baseUrl,
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status){
                    if(res.data.status.code==0){
                    }
                }
            })
        },
        getUsersF(){
             axios({
                method:'POST',
                url:'/getUsers',
                baseURL: this.baseUrl,
                data: {
                },
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status){
                    if(res.data.status.code==0){
                        this.user=res.data.content.user
                        this.users=res.data.content.users
                        this.permissions=res.data.content.permissions
                        this.getProcessesF()
                         
                    }
                }
            })
        },
        cancel() {
            this.$emit("changeHeader")
            this.showList = true
        }
    },
  
}
</script>

<style scoped>
    .createProcessModalHeader{
        text-align: center;
        color: rgba(51, 51, 51, 0.8);
        font-weight: bold;
        font-size: 18px;
    }
</style>


